/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourceTypeMetricDto
 */
export interface ResourceTypeMetricDto {
    /**
     * The description of the metric.
     * @type {string}
     * @memberof ResourceTypeMetricDto
     */
    description: string;
}

/**
 * Check if a given object implements the ResourceTypeMetricDto interface.
 */
export function instanceOfResourceTypeMetricDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function ResourceTypeMetricDtoFromJSON(json: any): ResourceTypeMetricDto {
    return ResourceTypeMetricDtoFromJSONTyped(json, false);
}

export function ResourceTypeMetricDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceTypeMetricDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
    };
}

export function ResourceTypeMetricDtoToJSON(value?: ResourceTypeMetricDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
    };
}

